import isNumber from 'lodash/isNumber';
import inRange from 'lodash/inRange';

const requireFields = (values, required) => (
		required.reduce((errors, field) => values[field] ?
										errors : Object.assign(errors, {[field]: 'Required'}), {})
);
const minLength = (field, min) => field && (field.length < min);
const validate = values => {
		const errors = requireFields(values, [ 'name', 'describes' ]);

		const current_year = new Date().getFullYear();
		if (values.birth_year && !inRange(values.birth_year, 1900, current_year)) {
				if (values.birth_year < 1900) {
						errors.birth_year = 'How old you are, not how old you feel';
				} else if ( values.birth_year === current_year+1) {
						errors.birth_year = 'Visiting from the womb, eh?';
				} else if ( values.birth_year > current_year) {
						errors.birth_year = 'Visiting from the future, eh?';
				} else {
						errors.birth_year = `Enter a year betwen 1900 and ${current_year}`;
        }
		}

		if (values.zipcode && !/^\d{5}$/.test(values['zipcode'])) {
				errors.zipcode = 'Enter a valid US zipcode';
		}

		return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/app/containers/Profile/validate.ts